import { KycErrorType, KycOutcome, KycProviderName, TKycProviderOutput } from '../../../types/data';

export enum PersonaResult {
    COMPLETED = 'completed',
    FAILED = 'failed',
    CANCEL = 'cancel',
    ERROR = 'error',
}

// Mapping per KycProvider wiki → Outcomes → Persona.
export const PERSONA_OUTCOME: Record<PersonaResult, Omit<TKycProviderOutput, 'providerStatus' | 'inquiryId'>> = {
    [PersonaResult.COMPLETED]: { provider: KycProviderName.PERSONA, outcome: KycOutcome.SUCCESS, errorType: null },
    [PersonaResult.FAILED]: { provider: KycProviderName.PERSONA, outcome: KycOutcome.ERROR, errorType: KycErrorType.VERIFICATION_REJECTED },
    [PersonaResult.CANCEL]: { provider: KycProviderName.PERSONA, outcome: KycOutcome.CANCEL, errorType: null },
    [PersonaResult.ERROR]: { provider: KycProviderName.PERSONA, outcome: KycOutcome.ERROR, errorType: KycErrorType.PROVIDER_ERROR },
};
